<!--suppress CssUnusedSymbol -->
<template>
  <div class="documents">
    <section class="content-header">
      <h1>{{ $t('menu.documents') }}</h1>
    </section>
    <section class="content">
      <browser-file />
    </section>
  </div>
</template>

<script>
import BrowserFile from '../components/browser_file/BrowserFile'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'document',
  components: {
    'browser-file': BrowserFile
  }
}
</script>
